import React, { useCallback, useEffect, useState } from 'react';
import PeriodDialog from './Dialog';
import { Alert, Box, Typography } from '@mui/material';
import List from './List';
import { useSelector } from 'react-redux';
import ButtonStartIcon from '../../../../../button/ButtonStartIcon';
import { handlerErrorV2 } from '../../../../../../utils/errors';
import { getSettingSubModule } from '../../../../../../services/periodical-report/periodical-report-setting.service';
import SelectCurriculum from '../../SelectCustom/SelectCurriculum';
import InputField from '../../../../../FormControl/input/InputField';

const Period = ({ curriculum, isLoadingCurriculum }) => {
  const [modal, setModal] = useState(null);
  const [update, setUpdate] = useState(false);
  const [list, setList] = useState([]);
  const [listTemp, setListTemp] = useState([]);
  const [isLoadingList, setIsLoadingList] = useState(false);
  const [filter, setFilter] = useState({});
  const [error, setError] = useState(null);
  const permission = useSelector((state) => state?.session?.permissions?.['periodical-report-period'] || {});

  const onLoad = useCallback(async () => {
    setIsLoadingList(true);
    try {
      const response = await getSettingSubModule('period')
      if (!response?.data && response?.error) {
        setError(response.error.message || 'An error ocurred');
      } else {
        setList(response?.data || []);
        setListTemp(response?.data || []);
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      setError(message);
    } finally {
      setIsLoadingList(false);
    }
  }, []);

  const onSearch = (key, value) => {
    setFilter({ ...filter, [key]: value });
    if (value.length === 0) {
      setList(listTemp);
    } else if (key === 'curriculumId') {
      const filterData = listTemp.filter((item) => item.curriculumId === value);
      setList(filterData);
    } else {
      const filterData = listTemp.filter((item) =>
        item.name.toLowerCase().includes(value.toLowerCase()) ||
        item.code.toLowerCase().includes(value.toLowerCase())
      );
      setList(filterData);
    }
  };

  useEffect(() => {
    onLoad();
  }, [onLoad, update]);

  return (
    <>
      <Box className='bg-primary text-primary-foreground px-4 py-1 flex gap-4 items-center justify-between sticky top-0 z-10 h-8'>
        <Typography variant='subtitle1' className='uppercase'>
          Period
        </Typography>
        {!isLoadingList && permission['created'] && (
          <ButtonStartIcon
            onClick={() => setModal({ type: 'create', form: {} })}
            color='secondary'
            variant='contained'
            startIcon={['fas', 'plus']}
          >
            Create
          </ButtonStartIcon>
        )}
      </Box>
      <div className='flex gap-2 items-center justify-between items-center py-2'>
        <div className='flex gap-2 justify-start'>
          <ButtonStartIcon
            variant='text'
            startIcon='bars-filter'
            title='Filter'
            color='primary'
            classNameIcon='text-3xl'
            size='large'
          >
            Filter
          </ButtonStartIcon>
          <div className='max-w-200px min-w-200px'>
            <SelectCurriculum
              value={filter?.curriculumId || ''}
              onChange={(e) => onSearch('curriculumId', e.target.value)} 
              onClear={() => onSearch('curriculumId', '')}
            />
          </div>
          <div className='max-w-250px'>
            <InputField placeholder='Search' onChange={(e) => onSearch('search', e.target.value)} />
          </div>
        </div>
      </div>
      <Box className='px-2 py-2 absolute top-24 bottom-0 inset-x-0'>
        {error ? (
          <Alert severity='error'>{error}</Alert>
        ) : (
          <List
            isLoading={isLoadingList || isLoadingCurriculum}
            permissions={permission}
            list={
              list
                ?.sort((a, b) => a.code - b.code)
                ?.map((item) => {
                  const curriculumData = curriculum?.find((cur) => cur._id === item.curriculumId);
                  return { ...item, curriculum: curriculumData?.name || 'General' };
                }) || []
            }
            onAction={(type, form) => setModal({ type, form })}
          />
        )}
      </Box>
      {modal && (
        <PeriodDialog
          type={modal.type}
          show={!!modal}
          onClose={() => setModal(null)}
          formData={modal.form}
          onReset={() => setUpdate(!update)}
        />
      )}
    </>
  );
};

export default Period;
